import { useState } from 'react'

import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import type { Entity } from '@models/Entity'

import { SelectObject } from '../../../../core/components/SelectObject'
import type { GroupedFilterOption } from '../../../../core/models/Filter'
import { StyledError } from '../../../../theme/components/StyledError'
import { useCompleteAssignedBijlageForEntity } from '../../hooks/useCompleteAssignedBijlageForEntity'
import type { AssignedBijlage } from '../../types/AssignedBijlage'

interface Props {
  assignees: GroupedFilterOption[]
  bijlage: AssignedBijlage
  entity: Entity
  onClose: () => void
}

export const Opleveren = ({ bijlage, assignees, entity, onClose }: Props) => {
  const { mutate: completeAssignedBijlageForEntity, error } =
    useCompleteAssignedBijlageForEntity()
  const [assignedTo, setAssignedTo] = useState<GroupedFilterOption | null>(null)
  const [errors, setErrors] = useState({})
  const { documentsoort, _id, requiresReview } = bijlage

  const onClick = () => {
    if (requiresReview && !assignedTo) {
      setErrors({ assignedToError: true })
      return
    }

    setErrors({})

    completeAssignedBijlageForEntity(
      {
        entity,
        assignedTo: assignedTo?.label,
        id: _id,
      },
      { onSuccess: () => onClose() },
    )
  }

  return (
    <>
      <DialogTitle>Opleveren bijlage</DialogTitle>

      <DialogContent>
        <StyledError error={error} />

        <DialogContentText>
          {requiresReview
            ? `Als u deze bijlage ${documentsoort} wilt laten beoordelen, kies dan de beoordelende organisatie`
            : `Wilt u deze bijlage ${documentsoort} opleveren?`}
        </DialogContentText>

        {requiresReview && (
          <SelectObject
            sx={{ width: '50%', pr: 1, pt: 2 }}
            options={assignees.filter((x) => x.label !== bijlage.assignedTo)}
            onChange={setAssignedTo}
            value={assignedTo}
            label="Beoordelen door"
            error={errors['assignedToError']}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuleren</Button>
        <Button
          onClick={onClick}
          startIcon={<PlaylistPlayIcon />}
          sx={{ color: 'green', border: '1px solid green' }}
        >
          {requiresReview ? 'Ter beoordeling aanbieden' : 'Opleveren'}
        </Button>
      </DialogActions>
    </>
  )
}
